import React, { useState, useEffect } from 'react';
import { Save, Wrench, RefreshCw, Monitor, ClipboardCheck, ChevronDown, MapPin, Search, Plus, Snowflake, Printer, Server, Cpu, ArrowLeft, Image as ImageIcon, AlertTriangle } from 'lucide-react';

export default function FormularioMantenimientoSST({ usuario, onBack }) {
  const [vista, setVista] = useState('CATALOGO');
  const [equipoSeleccionado, setEquipoSeleccionado] = useState(null);

  // CLASES CSS
  const inputClasesEsmeralda = "w-full px-4 !m-0 h-[48px] bg-white/60 backdrop-blur-md border border-white/60 rounded-xl text-sm font-bold text-slate-800 outline-none focus:bg-white focus:ring-2 focus:ring-emerald-500 shadow-inner transition-all";
  const selectClasesEsmeralda = "w-full pl-4 pr-10 !m-0 h-[48px] bg-white/60 backdrop-blur-md border border-white/60 rounded-xl text-sm font-bold text-slate-800 outline-none focus:bg-white focus:ring-2 focus:ring-emerald-500 appearance-none cursor-pointer shadow-inner transition-all";
  const inputClasesAmbar = "w-full px-4 h-[48px] bg-slate-100/50 backdrop-blur-md border border-slate-200 rounded-xl text-sm font-bold text-slate-500 cursor-not-allowed shadow-inner";

  // ESTADOS GLOBALES
  const [sedes, setSedes] = useState([]);
  const [equipos, setEquipos] = useState([]);
  const [cargandoCatalogo, setCargandoCatalogo] = useState(true);
  const [busqueda, setBusqueda] = useState('');
  const [sedeFiltro, setSedeFiltro] = useState('TODAS');

  const [cargando, setCargando] = useState(false);
  const [mensajeExito, setMensajeExito] = useState('');
  const [error, setError] = useState('');

  // ESTADO MANTENIMIENTO
  const [formData, setFormData] = useState({
    sede: '', tipoEquipo: '', marcaEquipo: '', modeloEquipo: '', serialEquipo: '', placaInventario: '',
    tipoMantenimiento: 'PREVENTIVO', fallaDetectada: 'SIN_FALLAS', 
    fechaMantenimiento: '', empresaProveedor: '', nombreTecnico: '', estadoEquipo: 'OPERATIVO', temperatura: '', descripcion: ''
  });

  // ESTADO CREAR NUEVO EQUIPO
  const [nuevoEquipo, setNuevoEquipo] = useState({
    nombre_equipo: '', tipo_equipo: 'NEVERAS', marca_referencia: '', modelo: '', serial_equipo: '', placa_inventario: '', sede_nombre: usuario?.centroTrabajo || '', foto_base64: ''
  });

  // ==========================================
  // CARGA ULTRA RÁPIDA EN 2 ETAPAS (DATOS -> FOTOS)
  // ==========================================
  useEffect(() => {
    let activo = true;
    const token = localStorage.getItem("token");
    const headers = { ...(token && { Authorization: `Bearer ${token}` }) };
    const apiUrl = process.env.REACT_APP_API_URL;

    const cargarDatos = async () => {
      setCargandoCatalogo(true);

      // 1. Sedes en paralelo
      fetch(`${apiUrl}/api/sedes`, { headers })
        .then(r => r.json())
        .then(dataSedes => {
          if (!activo) return;
          const listaSedes = Array.isArray(dataSedes) ? dataSedes : (dataSedes.data || dataSedes.sedes || []);
          setSedes(listaSedes);
        })
        .catch(err => console.error("Error cargando sedes:", err));

      // 2. Primero cargamos los metadatos de los equipos SIN el peso de foto_base64 (?ligero=1)
      try {
        const resEquipos = await fetch(`${apiUrl}/api/equipos?ligero=1`, { headers });
        if (resEquipos.ok) {
          const dataEquipos = await resEquipos.json();
          const listaRaw = Array.isArray(dataEquipos) ? dataEquipos : (dataEquipos.data || dataEquipos.equipos || dataEquipos.items || []);
          
          const listaNormalizada = listaRaw.map(eq => ({
            ...eq,
            id: eq.id || Math.random(),
            nombre_equipo: String(eq.nombre_equipo || eq.nombre || eq.modelo || eq.placa || "Equipo sin nombre"),
            tipo_equipo: String(eq.tipo_equipo || eq.tipo || "NEVERAS"),
            marca_referencia: String(eq.marca_referencia || eq.marca || ""),
            modelo: String(eq.modelo || ""),
            serial_equipo: String(eq.serial_equipo || eq.serial || eq.placa || "S/N"),
            placa_inventario: String(eq.placa_inventario || eq.placa || ""),
            sede_nombre: String(eq.sede_nombre || eq.sede || eq.pdv_centro || "OFICINAS"),
            estado_actual: String(eq.estado_actual || eq.estado || "OPERATIVO"),
            foto_base64: eq.foto_base64 || null
          }));

          if (activo) {
            setEquipos(listaNormalizada);
            setCargandoCatalogo(false);
          }
    // 3. Hidratamos cada foto de manera progresiva y con caché del navegador
              const equiposConFoto = listaNormalizada.filter(e => !e.foto_base64 && e.tiene_foto);
              equiposConFoto.forEach((eqItem) => {
                fetch(`${apiUrl}/api/equipos/foto/${eqItem.id}`, { headers })
                  .then(r => r.json())
                  .then(dFoto => {
                    if (!activo || !dFoto?.foto_base64) return;
                    setEquipos(prev => prev.map(item =>
                      item.id === eqItem.id ? { ...item, foto_base64: dFoto.foto_base64 } : item
                    ));
                  })
                  .catch(() => {});
              });
        } else {
          if (activo) setCargandoCatalogo(false);
        }
      } catch (err) {
        console.error("Aviso: No se pudieron cargar los equipos.", err);
        if (activo) setCargandoCatalogo(false);
      }
    };
    
    cargarDatos();
    return () => { activo = false; };
  }, []);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const MAX_WIDTH = 800;
        const scaleSize = img.width > MAX_WIDTH ? MAX_WIDTH / img.width : 1;
        canvas.width = img.width * scaleSize;
        canvas.height = img.height * scaleSize;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        const compressedBase64 = canvas.toDataURL('image/jpeg', 0.72);
        setNuevoEquipo(prev => ({ ...prev, foto_base64: compressedBase64 }));
      };
      img.src = event.target.result;
    };
    reader.readAsDataURL(file);
  };

  const handleGuardarNuevoEquipo = async (e) => {
    e.preventDefault();
    setCargando(true); setError('');
    try {
      const token = localStorage.getItem("token");
      const apiUrl = process.env.REACT_APP_API_URL;
      const res = await fetch(`${apiUrl}/api/equipos/guardar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...(token && { Authorization: `Bearer ${token}` }) },
        body: JSON.stringify(nuevoEquipo)
      });
      const data = await res.json();
      if (res.ok || data.success) {
        const equipoCreado = { ...nuevoEquipo, id: data.id || Date.now(), estado_actual: 'OPERATIVO' };
        setEquipos([equipoCreado, ...equipos]);
        setMensajeExito('Hoja de vida del equipo creada correctamente.');
        setTimeout(() => {
          setMensajeExito(''); setVista('CATALOGO');
          setNuevoEquipo({ nombre_equipo: '', tipo_equipo: 'NEVERAS', marca_referencia: '', modelo: '', serial_equipo: '', placa_inventario: '', sede_nombre: '', foto_base64: '' });
        }, 2000);
      } else {
        setError(`Error al guardar: ${data.message || 'Error desconocido'}`);
      }
    } catch (err) {
      setError('Error de conexión al guardar el equipo.');
    } finally {
      setCargando(false);
    }
  };

  const abrirFormularioMantenimiento = (equipo) => {
    setEquipoSeleccionado(equipo);
    setFormData(prev => ({
      ...prev,
      sede: equipo.sede_nombre || '',
      tipoEquipo: equipo.tipo_equipo || '',
      marcaEquipo: equipo.marca_referencia || '',
      modeloEquipo: equipo.modelo || '',
      serialEquipo: equipo.serial_equipo || '',
      placaInventario: equipo.placa_inventario || '',
      estadoEquipo: equipo.estado_actual || 'OPERATIVO'
    }));
    setVista('FORMULARIO');
  };

  const handleSubmitMantenimiento = async (e) => {
    e.preventDefault();
    setCargando(true); setError('');
    try {
      const token = localStorage.getItem("token");
      const apiUrl = process.env.REACT_APP_API_URL;
      const payload = {
        tipo_formulario: 'MANTENIMIENTO_EQUIPOS_SST',
        datosGenerales: { fecha: formData.fechaMantenimiento || new Date().toISOString(), pdv: formData.sede, evaluador: usuario?.terc_nom || usuario?.nombres || 'Administrador' },
        respuestas: { ...formData },
        observaciones: { general: formData.descripcion },
        puntaje_global: 100
      };

      const respuesta = await fetch(`${apiUrl}/api/formularios/guardar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...(token && { Authorization: `Bearer ${token}` }) },
        body: JSON.stringify(payload)
      });

      const data = await respuesta.json();
      if (respuesta.ok || data.success) {
        setMensajeExito('Evaluación guardada y hoja de vida actualizada.');
        setEquipos(prev => prev.map(eq => eq.serial_equipo === formData.serialEquipo ? { ...eq, estado_actual: formData.estadoEquipo } : eq));
        setTimeout(() => { setMensajeExito(''); setVista('CATALOGO'); setFormData(prev => ({ ...prev, fechaMantenimiento: '', empresaProveedor: '', nombreTecnico: '', temperatura: '', descripcion: '', tipoMantenimiento: 'PREVENTIVO', fallaDetectada: 'SIN_FALLAS' })); }, 2000);
      } else {
        setError(`Error: ${data.error || data.message || 'Datos incompletos'}`);
      }
    } catch (err) {
      setError('Error de red.');
    } finally {
      setCargando(false);
    }
  };

  const getIconoEquipo = (tipo) => {
    switch(String(tipo || '').toUpperCase()) {
      case 'NEVERAS': case 'CONGELADORES': case 'CAMARAS': return <Snowflake className="w-5 h-5 text-blue-500" />;
      case 'COMPUTADORES': case 'RACK': return <Server className="w-5 h-5 text-indigo-500" />;
      case 'FOTOCOPIADORAS': return <Printer className="w-5 h-5 text-slate-500" />;
      default: return <Cpu className="w-5 h-5 text-amber-500" />;
    }
  };

  const opcionesSedes = Array.from(
    new Set([
      ...sedes.map(s => String(s.nombre || '').trim()).filter(Boolean),
      ...equipos.map(e => String(e.sede_nombre || '').trim()).filter(Boolean)
    ])
  );

  // ==========================================
  // VISTA 1: CATÁLOGO DE TARJETAS
  // ==========================================
  if (vista === 'CATALOGO') {
    const terminoBusqueda = String(busqueda || '').toLowerCase().trim();

    const equiposFiltrados = equipos.filter(eq => {
      const sedeEq = String(eq.sede_nombre || '').trim().toUpperCase();
      const filtroUpper = String(sedeFiltro || 'TODAS').trim().toUpperCase();

      const coincideSede = filtroUpper === 'TODAS' || !filtroUpper || sedeEq === filtroUpper || sedeEq.includes(filtroUpper);

      const nombreEq = String(eq.nombre_equipo || '').toLowerCase();
      const serialEq = String(eq.serial_equipo || '').toLowerCase();
      const placaEq = String(eq.placa_inventario || '').toLowerCase();
      const marcaEq = String(eq.marca_referencia || '').toLowerCase();

      const coincideBusqueda = !terminoBusqueda || 
        nombreEq.includes(terminoBusqueda) || 
        serialEq.includes(terminoBusqueda) || 
        placaEq.includes(terminoBusqueda) ||
        marcaEq.includes(terminoBusqueda);

      return coincideSede && coincideBusqueda;
    });

    return (
      <div className="w-full max-w-7xl mx-auto px-4 py-6 animate-fade-in-up">
        {mensajeExito && <div className="mb-6 bg-emerald-100 border border-emerald-300 text-emerald-800 p-4 rounded-xl font-bold text-sm shadow-sm">{mensajeExito}</div>}
        <div className="bg-white/40 backdrop-blur-2xl rounded-[32px] p-6 sm:p-8 shadow-xl border border-white/60 mb-8 flex flex-col md:flex-row gap-6 justify-between items-center">
          <div>
            <h1 className="text-2xl sm:text-3xl font-black text-slate-800 tracking-tight flex items-center gap-3"><span className="text-3xl">🗂️</span> Hojas de Vida de Equipos</h1>
            <p className="text-sm font-bold text-slate-500 mt-1">Seleccione un equipo para registrar su mantenimiento o agregue uno nuevo.</p>
          </div>
          <div className="flex flex-col sm:flex-row w-full md:w-auto gap-4">
            <div className="relative w-full sm:w-56">
              <input type="text" placeholder="Buscar serial o nombre..." value={busqueda} onChange={(e) => setBusqueda(e.target.value)} className="w-full pl-10 pr-4 py-3 bg-white/60 border border-white/80 rounded-2xl text-sm font-bold text-slate-700 focus:ring-2 focus:ring-amber-500 outline-none shadow-sm" />
              <Search className="w-4 h-4 text-slate-400 absolute left-4 top-3.5" />
            </div>
            <select value={sedeFiltro} onChange={(e) => setSedeFiltro(e.target.value)} className="w-full sm:w-48 px-4 py-3 bg-white/60 border border-white/80 rounded-2xl text-sm font-bold text-slate-700 outline-none shadow-sm cursor-pointer">
              <option value="TODAS">Todas las Sedes</option>
              {opcionesSedes.map(nombreSede => <option key={nombreSede} value={nombreSede}>{nombreSede}</option>)}
            </select>
            <button onClick={() => setVista('CREAR_EQUIPO')} className="bg-amber-500 hover:bg-amber-600 text-white px-5 py-3 rounded-2xl font-black text-xs flex items-center justify-center gap-2 shadow-lg transition-all shrink-0">
              <Plus className="w-4 h-4" /> Nuevo Equipo
            </button>
            <button onClick={onBack} className="bg-white/60 hover:bg-white text-slate-800 px-5 py-3 rounded-2xl font-black text-xs flex items-center justify-center shadow-sm border border-slate-200 transition-all shrink-0">
              Volver al Menú
            </button>
          </div>
        </div>

        {cargandoCatalogo ? (
          <div className="bg-white/60 backdrop-blur-xl rounded-[28px] p-12 text-center border border-white/80 shadow-lg flex flex-col items-center justify-center gap-3">
            <RefreshCw className="w-8 h-8 text-amber-500 animate-spin" />
            <p className="text-base font-black text-slate-700">Cargando hojas de vida de equipos...</p>
          </div>
        ) : equiposFiltrados.length === 0 ? (
          <div className="bg-white/60 backdrop-blur-xl rounded-[28px] p-12 text-center border border-white/80 shadow-lg">
            <p className="text-base font-black text-slate-700">No se encontraron equipos registrados para este filtro.</p>
            <p className="text-xs font-bold text-slate-500 mt-1">Intenta cambiar la sede seleccionada o limpiar el cuadro de búsqueda.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {equiposFiltrados.map((equipo) => (
              <div key={equipo.id} className="bg-white/70 backdrop-blur-xl rounded-[28px] overflow-hidden shadow-lg border border-white/80 hover:-translate-y-1 transition-all group flex flex-col">
                <div className="h-48 w-full bg-slate-100 relative overflow-hidden">
                  {equipo.foto_base64 ? (
                    <img src={equipo.foto_base64} alt={equipo.nombre_equipo} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-slate-200">
                      <ImageIcon className="w-12 h-12 text-slate-400" />
                    </div>
                  )}
                  
                  <div className="absolute top-3 right-3 shadow-md">
                    {equipo.estado_actual === 'OPERATIVO' && <span className="bg-emerald-100 text-emerald-700 px-2.5 py-1 rounded-full text-[10px] font-black uppercase">Óptimo</span>}
                    {equipo.estado_actual === 'CON_OBSERVACIONES' && <span className="bg-amber-100 text-amber-700 px-2.5 py-1 rounded-full text-[10px] font-black uppercase">Revisar</span>}
                    {equipo.estado_actual === 'FUERA_DE_SERVICIO' && <span className="bg-rose-100 text-rose-700 px-2.5 py-1 rounded-full text-[10px] font-black uppercase">Dañado</span>}
                  </div>
                  <div className="absolute bottom-3 left-3 bg-white/90 backdrop-blur-md px-3 py-1.5 rounded-xl flex items-center gap-1.5 shadow-sm">
                    <MapPin className="w-3.5 h-3.5 text-rose-500" />
                    <span className="text-[10px] font-black text-slate-800">{equipo.sede_nombre}</span>
                  </div>
                </div>
                <div className="p-5 flex-1 flex flex-col">
                  <div className="flex items-start gap-3 mb-3">
                    <div className="p-2 bg-slate-100 rounded-xl border border-slate-200 shadow-sm shrink-0">
                      {getIconoEquipo(equipo.tipo_equipo)}
                    </div>
                    <h3 className="text-sm font-black text-slate-800 leading-tight line-clamp-2 mt-1">{equipo.nombre_equipo}</h3>
                  </div>
                  <div className="grid grid-cols-2 gap-2 mb-5 mt-auto">
                    <div className="bg-slate-50 p-2.5 rounded-xl border border-slate-100">
                      <p className="text-[9px] font-black uppercase text-slate-400">Marca/Mod</p>
                      <p className="text-xs font-bold text-slate-700 truncate">{equipo.marca_referencia} {equipo.modelo}</p>
                    </div>
                    <div className="bg-slate-50 p-2.5 rounded-xl border border-slate-100">
                      <p className="text-[9px] font-black uppercase text-slate-400">Placa/S-N</p>
                      <p className="text-xs font-bold text-slate-700 truncate">{equipo.placa_inventario || equipo.serial_equipo}</p>
                    </div>
                  </div>
                  <button onClick={() => abrirFormularioMantenimiento(equipo)} className="w-full py-3 bg-amber-50 hover:bg-amber-500 text-amber-700 hover:text-white rounded-xl text-xs font-black transition-colors flex items-center justify-center gap-2 border border-amber-200 hover:border-amber-500 shadow-sm">
                    <Wrench className="w-4 h-4" /> Realizar Mantenimiento
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  // ==========================================
  // VISTA 2: CREAR HOJA DE VIDA (NUEVO EQUIPO)
  // ==========================================
  if (vista === 'CREAR_EQUIPO') {
    return (
      <div className="w-full max-w-4xl mx-auto px-4 py-6 animate-fade-in">
        <div className="bg-white/20 backdrop-blur-3xl border border-white/40 shadow-2xl rounded-[34px] p-6 sm:p-10">
          <div className="flex justify-between items-center mb-8 border-b border-white/30 pb-6">
            <div>
              <h2 className="text-2xl font-black text-slate-800 flex items-center gap-2"><Plus className="text-amber-500" /> Crear Hoja de Vida</h2>
              <p className="text-sm font-bold text-slate-500">Registre un nuevo equipo en el sistema</p>
            </div>
            <button onClick={() => setVista('CATALOGO')} className="bg-white/60 hover:bg-white text-slate-800 px-4 py-2.5 rounded-xl font-black text-xs flex items-center gap-2 shadow-sm">
              <ArrowLeft className="w-4 h-4" /> Cancelar
            </button>
          </div>

          {error && <div className="mb-6 bg-rose-100 border border-rose-300 text-rose-800 p-4 rounded-xl font-bold text-sm shadow-sm">{error}</div>}
          {mensajeExito && <div className="mb-6 bg-emerald-100 border border-emerald-300 text-emerald-800 p-4 rounded-xl font-bold text-sm shadow-sm">{mensajeExito}</div>}

          <form onSubmit={handleGuardarNuevoEquipo} className="space-y-6">
            <div className="flex flex-col items-center justify-center w-full mb-6">
              <label className="flex flex-col items-center justify-center w-full h-48 border-2 border-dashed border-emerald-300 rounded-3xl cursor-pointer bg-emerald-50/50 hover:bg-emerald-50 transition-colors relative overflow-hidden">
                {nuevoEquipo.foto_base64 ? (
                  <img src={nuevoEquipo.foto_base64} alt="Preview" className="w-full h-full object-cover" />
                ) : (
                  <div className="flex flex-col items-center justify-center pt-5 pb-6">
                    <ImageIcon className="w-10 h-10 text-emerald-500 mb-3" />
                    <p className="text-sm font-bold text-slate-600">Clic para subir foto del equipo</p>
                  </div>
                )}
                <input type="file" className="hidden" accept="image/*" onChange={handleImageUpload} />
              </label>
            </div>

            <div className="bg-white/40 backdrop-blur-md rounded-3xl p-6 border border-white/60 shadow-sm grid grid-cols-1 md:grid-cols-2 gap-5">
              <div className="flex flex-col gap-1.5 md:col-span-2">
                <label className="text-[11px] font-black text-slate-500 uppercase">Nombre Descriptivo</label>
                <input type="text" required value={nuevoEquipo.nombre_equipo} onChange={e => setNuevoEquipo({...nuevoEquipo, nombre_equipo: e.target.value})} placeholder="Ej: Nevera Exhibidora Postobon" className={inputClasesEsmeralda} />
              </div>
              <div className="flex flex-col gap-1.5">
                <label className="text-[11px] font-black text-slate-500 uppercase">Sede Asignada</label>
                <div className="relative flex items-center w-full">
                  <select required value={nuevoEquipo.sede_nombre} onChange={e => setNuevoEquipo({...nuevoEquipo, sede_nombre: e.target.value})} className={selectClasesEsmeralda}>
                    <option value="">Seleccione...</option>
                    {opcionesSedes.map(nombreSede => <option key={nombreSede} value={nombreSede}>{nombreSede}</option>)}
                  </select>
                  <ChevronDown className="w-5 h-5 text-slate-400 absolute right-3 pointer-events-none" />
                </div>
              </div>
              <div className="flex flex-col gap-1.5">
                <label className="text-[11px] font-black text-slate-500 uppercase">Tipo de Equipo</label>
                <div className="relative flex items-center w-full">
                  <select value={nuevoEquipo.tipo_equipo} onChange={e => setNuevoEquipo({...nuevoEquipo, tipo_equipo: e.target.value})} className={selectClasesEsmeralda}>
                    {['NEVERAS', 'CONGELADORES', 'CAMARAS', 'COMPUTADORES', 'CAJAS_REGISTRADORAS', 'ELEVADOR_CARGA', 'FOTOCOPIADORAS', 'RACK', 'BALANZAS'].map(eq => <option key={eq} value={eq}>{eq}</option>)}
                  </select>
                  <ChevronDown className="w-5 h-5 text-slate-400 absolute right-3 pointer-events-none" />
                </div>
              </div>
              <div className="flex flex-col gap-1.5">
                <label className="text-[11px] font-black text-slate-500 uppercase">Marca</label>
                <input type="text" required value={nuevoEquipo.marca_referencia} onChange={e => setNuevoEquipo({...nuevoEquipo, marca_referencia: e.target.value})} placeholder="Ej: LG" className={inputClasesEsmeralda} />
              </div>
              <div className="flex flex-col gap-1.5">
                <label className="text-[11px] font-black text-slate-500 uppercase">Modelo</label>
                <input type="text" value={nuevoEquipo.modelo} onChange={e => setNuevoEquipo({...nuevoEquipo, modelo: e.target.value})} placeholder="Ej: ThinQ 2023" className={inputClasesEsmeralda} />
              </div>
              <div className="flex flex-col gap-1.5">
                <label className="text-[11px] font-black text-slate-500 uppercase">No. Placa (Inventario)</label>
                <input type="text" value={nuevoEquipo.placa_inventario} onChange={e => setNuevoEquipo({...nuevoEquipo, placa_inventario: e.target.value})} placeholder="Número de placa interna..." className={inputClasesEsmeralda} />
              </div>
              <div className="flex flex-col gap-1.5">
                <label className="text-[11px] font-black text-slate-500 uppercase">Serial (S/N)</label>
                <input type="text" required value={nuevoEquipo.serial_equipo} onChange={e => setNuevoEquipo({...nuevoEquipo, serial_equipo: e.target.value})} placeholder="Número de serie del fabricante..." className={inputClasesEsmeralda} />
              </div>
            </div>
            
            <button type="submit" disabled={cargando} className="w-full py-4 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl text-sm font-black uppercase tracking-wider shadow-lg transition-all flex justify-center items-center gap-2">
              {cargando ? <RefreshCw className="w-5 h-5 animate-spin" /> : <Save className="w-5 h-5" />} Guardar Hoja de Vida
            </button>
          </form>
        </div>
      </div>
    );
  }

  // ==========================================
  // VISTA 3: FORMULARIO DE MANTENIMIENTO 
  // ==========================================
  const requiereTemperatura = ['NEVERAS', 'CONGELADORES', 'CAMARAS'].includes(formData.tipoEquipo);

  return (
    <div className="w-full max-w-4xl mx-auto px-2 sm:px-4 py-4 sm:py-6 animate-fade-in">
      <div className="bg-white/20 backdrop-blur-3xl border border-white/40 shadow-2xl rounded-[34px] p-6 sm:p-10">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8 border-b border-white/30 pb-6">
          <div>
            <h2 className="text-xl sm:text-3xl font-black text-slate-800 tracking-tight flex items-center gap-3">
              <div className="p-2 bg-amber-100 rounded-xl border border-amber-200"><Wrench className="w-6 h-6 text-amber-600" /></div>
              Detalle de Mantenimiento
            </h2>
            <p className="text-sm font-bold text-slate-600 mt-2">Equipo Seleccionado: <span className="text-amber-600 uppercase">{equipoSeleccionado?.nombre_equipo}</span></p>
          </div>
          <button onClick={() => setVista('CATALOGO')} className="flex items-center justify-center gap-2 bg-white/60 hover:bg-white/80 text-slate-800 px-4 py-2.5 rounded-xl border border-white/60 shadow-sm font-black text-xs">
            <ArrowLeft className="w-4 h-4" /> Volver al Catálogo
          </button>
        </div>

        {error && <div className="mb-6 bg-rose-100 border border-rose-300 text-rose-800 p-4 rounded-xl font-bold text-sm shadow-sm">{error}</div>}

        <form onSubmit={handleSubmitMantenimiento} className="space-y-6">
          <div className="bg-white/40 backdrop-blur-md rounded-3xl p-6 border border-white/60 shadow-sm">
            <h3 className="text-amber-600 font-black text-sm mb-5 uppercase tracking-wider flex items-center gap-2">
              <Monitor className="w-5 h-5" /> 1. Información Técnica Fija
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
              <div className="flex flex-col gap-1.5"><label className="text-[10px] font-black text-slate-500 uppercase">Sede</label><input type="text" value={formData.sede} readOnly className={inputClasesAmbar} /></div>
              <div className="flex flex-col gap-1.5"><label className="text-[10px] font-black text-slate-500 uppercase">Tipo</label><input type="text" value={formData.tipoEquipo} readOnly className={inputClasesAmbar} /></div>
              <div className="flex flex-col gap-1.5"><label className="text-[10px] font-black text-slate-500 uppercase">Marca / Mod</label><input type="text" value={`${formData.marcaEquipo} ${formData.modeloEquipo || ''}`} readOnly className={inputClasesAmbar} /></div>
              <div className="flex flex-col gap-1.5"><label className="text-[10px] font-black text-slate-500 uppercase text-rose-500">Placa / Serial</label><input type="text" value={formData.placaInventario || formData.serialEquipo} readOnly className={`${inputClasesAmbar} border-rose-200 bg-rose-50/50 text-rose-700`} /></div>
            </div>
          </div>

          <div className="bg-white/40 backdrop-blur-md rounded-3xl p-6 border border-white/60 shadow-sm">
            <h3 className="text-emerald-600 font-black text-sm mb-5 uppercase tracking-wider flex items-center gap-2"><ClipboardCheck className="w-5 h-5" /> 2. Detalle del Mantenimiento</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 items-start">
              
              <div className="flex flex-col gap-1.5">
                <label className="text-[11px] font-black text-slate-500 uppercase">Tipo de Mantenimiento</label>
                <div className="relative flex items-center w-full">
                  <select name="tipoMantenimiento" value={formData.tipoMantenimiento} onChange={(e)=>setFormData({...formData, tipoMantenimiento: e.target.value})} className={selectClasesEsmeralda}>
                    <option value="PREVENTIVO">Preventivo</option>
                    <option value="CORRECTIVO">Correctivo</option>
                    <option value="INSTALACION">Instalación</option>
                    <option value="DESMONTAJE">Desmontaje</option>
                  </select>
                  <ChevronDown className="w-5 h-5 text-slate-400 absolute right-3 pointer-events-none" />
                </div>
              </div>

              <div className="flex flex-col gap-1.5">
                <label className="text-[11px] font-black text-slate-500 uppercase flex items-center gap-1"><AlertTriangle className="w-3.5 h-3.5" /> Falla Detectada</label>
                <div className="relative flex items-center w-full">
                  <select name="fallaDetectada" value={formData.fallaDetectada} onChange={(e)=>setFormData({...formData, fallaDetectada: e.target.value})} className={selectClasesEsmeralda}>
                    <option value="SIN_FALLAS">Sin Fallas (Todo Ok)</option>
                    <option value="DEPRECIACION">Desgaste / Depreciación</option>
                    <option value="MALA_OPERACION">Mala Operación</option>
                    <option value="MAL_INSTALADO">Mal Instalado</option>
                    <option value="ACCESORIOS">Daño en Accesorios</option>
                    <option value="DESCONOCIDA">Causa Desconocida</option>
                  </select>
                  <ChevronDown className="w-5 h-5 text-slate-400 absolute right-3 pointer-events-none" />
                </div>
              </div>

              <div className="flex flex-col gap-1.5">
                <label className="text-[11px] font-black text-slate-500 uppercase">Nuevo Estado del Equipo</label>
                <div className="relative flex items-center w-full">
                  <select name="estadoEquipo" value={formData.estadoEquipo} onChange={(e)=>setFormData({...formData, estadoEquipo: e.target.value})} className={selectClasesEsmeralda}>
                    <option value="OPERATIVO">Bueno / Operativo</option>
                    <option value="CON_OBSERVACIONES">Regular (Con Obs.)</option>
                    <option value="FUERA_DE_SERVICIO">Malo / Dañado</option>
                    <option value="DESARMADO">Desarmado</option>
                  </select>
                  <ChevronDown className="w-5 h-5 text-slate-400 absolute right-3 pointer-events-none" />
                </div>
              </div>

              <div className="flex flex-col gap-1.5"><label className="text-[11px] font-black text-slate-500 uppercase">Fecha de Servicio</label><input type="date" name="fechaMantenimiento" value={formData.fechaMantenimiento} onChange={(e)=>setFormData({...formData, fechaMantenimiento: e.target.value})} required className={inputClasesEsmeralda} /></div>
              <div className="flex flex-col gap-1.5"><label className="text-[11px] font-black text-slate-500 uppercase">Empresa Contratista</label><input type="text" name="empresaProveedor" value={formData.empresaProveedor} onChange={(e)=>setFormData({...formData, empresaProveedor: e.target.value})} required className={inputClasesEsmeralda} /></div>
              <div className="flex flex-col gap-1.5"><label className="text-[11px] font-black text-slate-500 uppercase">Técnico Responsable</label><input type="text" name="nombreTecnico" value={formData.nombreTecnico} onChange={(e)=>setFormData({...formData, nombreTecnico: e.target.value})} required className={inputClasesEsmeralda} /></div>

              {requiereTemperatura && (
                <div className="flex flex-col gap-1.5">
                  <label className="text-[11px] font-black text-slate-500 uppercase">Temp. Actual (°C)</label>
                  <input type="number" step="0.1" name="temperatura" value={formData.temperatura} onChange={(e)=>setFormData({...formData, temperatura: e.target.value})} required className={inputClasesEsmeralda} />
                </div>
              )}

              <div className={`flex flex-col gap-2 mt-2 w-full ${requiereTemperatura ? 'md:col-span-2' : 'md:col-span-3'}`}>
                <label className="text-[11px] font-black text-slate-500 uppercase">Observaciones Detalladas</label>
                <textarea name="descripcion" value={formData.descripcion} onChange={(e)=>setFormData({...formData, descripcion: e.target.value})} required rows="2" placeholder="Describa el trabajo realizado..." className="w-full px-4 py-3 bg-white/60 border border-white/60 rounded-xl text-sm font-medium text-slate-800 outline-none focus:ring-2 focus:ring-emerald-500 resize-none"></textarea>
              </div>
            </div>
          </div>

          <div className="pt-2 flex justify-end">
            <button type="submit" disabled={cargando} className="px-8 py-3.5 bg-gradient-to-r from-emerald-500 to-teal-500 text-white rounded-xl text-sm font-black uppercase tracking-wider shadow-lg flex items-center gap-2">
              {cargando ? <RefreshCw className="w-5 h-5 animate-spin" /> : <Save className="w-5 h-5" />} Guardar Mantenimiento
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}